export default __webpack_public_path__ + "static/media/contactPhone.f60b5927.svg";